import { render, staticRenderFns } from "./schedule-compact.vue?vue&type=template&id=5cdd2766&scoped=true"
import script from "./schedule-compact.vue?vue&type=script&lang=js"
export * from "./schedule-compact.vue?vue&type=script&lang=js"
import style0 from "./schedule-compact.vue?vue&type=style&index=0&id=5cdd2766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdd2766",
  null
  
)

export default component.exports